<div class="panel-container">
    <div  class="panel-title">
        <h3>
            EXPIRED DRAFT
            <span (click)="cancel()" id="close-popup">
                <i class="material-icons close-icon">close</i>
            </span>
        </h3>
    </div>

    <div class="panel-content">
        <p>
            The Draft policy <b>{{PolicyName}}</b> you are resuming and trying to convert has expired. 
            <br />
            Please create a new draft and ensure the policy details still meet your client’s needs and requirements. Also be mindful of any price changes that may now apply.
        </p>
    </div>

    <div class="col-md-12 footer">
        <div class="row">
            <div class="col-12 center">
                <button type="button" class="col-md-3 white-button" style="margin-left:15px;" (click)="cancel()">
                    <span style="font-size: 16px; position: relative; bottom: 1px; letter-spacing: 0.4px; color: #292929">Cancel</span>
                </button>
                <button type="button" class="col-md-3 frontend-primary-button" (click)="newDraft()" style="height: 40px; font-size: 15px;">
                    Create New Draft
                </button>
            </div>
        </div>
    </div>
</div>